/**
 * @file shared/utils/errores.ts
 * @description FUENTE ÚNICA DE VERDAD para extraer mensaje/código de un `catch (error)`
 * tipado como `unknown` (obligatorio con `strict: true`). Reemplaza el patrón
 * `catch (error: any) { ...error.message... }` repetido en decenas de archivos.
 * REGLA DURA: TypeScript puro — sin imports de firebase, DOM ni Node.
 */

/** Mensaje legible de cualquier valor atrapado en un catch. */
export function getErrorMessage(e: unknown): string {
  if (e instanceof Error) return e.message;
  if (typeof e === "string") return e;
  return String(e);
}

/** Código de error (p. ej. los errores de Firebase traen `.code`), si existe. */
export function getErrorCode(e: unknown): string | undefined {
  if (e && typeof e === "object" && typeof (e as { code?: unknown }).code === "string") {
    return (e as { code: string }).code;
  }
  return undefined;
}
